// extracted by mini-css-extract-plugin
export var project_details_wrapper = "ProjectDetails-module--project_details_wrapper--kGVQv";
export var project_details = "ProjectDetails-module--project_details--Xp+vB";
export var project_details_title = "ProjectDetails-module--project_details_title--lFRvq";
export var project_date = "ProjectDetails-module--project_date--5cm8X";
export var project_duration = "ProjectDetails-module--project_duration--9i-i-";
export var project_techs = "ProjectDetails-module--project_techs--p4C4s";
export var project_link = "ProjectDetails-module--project_link--NMUXF";
export var project_repository = "ProjectDetails-module--project_repository--qa---";